<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <AppTooltip width="w-[360px]" tooltip-position="bottom">
    <BaseIcon name="IconoirInfoCircle" class="h-4 w-4 cursor-pointer text-foreground-secondary" />
    <template #tooltip-content>
      <div class="flex flex-col gap-2 text-left">
        <p>{{ t('pages.autopilot.autopilotsPage.data.conversionTooltip') }}</p>
        <p>
          {{ t('pages.autopilot.autopilotsPage.data.conversionTooltip2') }}
        </p>
      </div>
    </template>
  </AppTooltip>
</template>
